<template>
    <div class="home-slider">
        <div class="swiper-container home-slider__slider-container" ref="swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="entry in entries">
                    <div class="home-slider__images">
                        <div class="home-slider__images--left">
                            <picture>
                                <source media="(max-width: 767px)" :srcset="entry.imageMobilLeft">
                                <source media="(min-width: 768px)" :srcset="entry.imageDesktopLeft">
                                <img class="home-slider__image" :src="entry.imageDesktopLeft" loading="lazy"
                                     :alt="entry.headline">
                            </picture>
                        </div>
                        <div class="home-slider__images--right" v-if="!isMobile">
                            <picture>
                                <source media="(max-width: 767px)" :srcset="entry.imageMobilRight">
                                <source media="(min-width: 768px)" :srcset="entry.imageDesktopRight">
                                <img class="home-slider__image" :src="entry.imageMobilRight" loading="lazy"
                                     :alt="entry.headline">
                            </picture>
                        </div>
                    </div>
                    <div class="home-slider__content-wrapper" v-if="!isMobile">
                        <div class="home-slider__content" :style="'background-color: '+ entry.dreieckFarbe">
                            <div class="home-slider__content-txt">
                                <div v-html="entry.headline" :style="'color: '+ entry.dreieckTextFarbe" class="home-slider__slider-headline"></div>
                                <div v-html="entry.text" :style="'color: '+ entry.dreieckTextFarbe" class="home-slider__slider-subheadline"></div>
                                <a :href="entry.buttonUrl" :alt="entry.buttonText" :style="'background-color: '+ entry.dreieckButtonFarbe" class="home-slider__slider-button">
                                    <div class="home-slider__slider-button--hover-rect" :style="'background-color: '+ entry.dreieckButtonFarbeHover"></div>
                                    {{ entry.buttonText }}
                                </a>
                            </div>
                        </div>
                    </div>


                    <div class="home-slider-mobile__content-wrapper" v-if="isMobile">
                        <div class="home-slider-mobile__background">
                            <div class="home-slider-mobile__background--left" :style="'background-color: '+ entry.bannerFarbeLinks"></div>
                            <div class="home-slider-mobile__background--right" :style="'background-color: '+ entry.bannerFarbeRechts">
                                <div class="home-slider-mobile__background--triangle" :style="'border-color: transparent transparent '+entry.bannerFarbeRechts+' transparent'"></div>
                            </div>
                        </div>

                        <div class="home-slider-mobile__content" :style="'background-color: '+ entry.dreieckFarbe">
                            <div class="home-slider-mobile__content-txt">
                                <div v-html="entry.headline" :style="'color: #585858'" class="home-slider-mobile__slider-headline"></div>
                                <div v-html="entry.text" :style="'color: '+ entry.dreieckTextFarbe" class="home-slider-mobile__slider-subheadline"></div>
                                <a :href="entry.buttonUrl" :alt="entry.buttonText" :style="'background-color: '+ entry.dreieckButtonFarbeMobil" class="home-slider-mobile__slider-button">{{ entry.buttonText }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="home-slider__prev">
            <!--<i class="fa fa-chevron-left"></i>-->
            <i class="icon-left" style="font-size:20px"></i>
        </div>
        <div class="home-slider__next">
            <!--<i class="fa fa-chevron-right"></i>-->
            <i class="icon-right" style="font-size:20px"></i>
        </div>
        <div class="home-slider__pagination"></div>
    </div>
</template>

<script>

    import { Swiper } from 'swiper';

    export default {
        props: {
            bemclass: {
                type: String,
                default: ""
            },
            entries: {
                type: Array,
                default: () => []
            }
        },

        data(){
            return{
                isMobile: false
            }
        },

        mounted()
        {
            this.$nextTick(() =>
            {
                this.isMobile = window.innerWidth < 768;
                this.initSwiper();
            });
        },

        methods: {
            initSwiper(){
                const swiper = new Swiper(".home-slider__slider-container", {
                    pagination: {
                        el: ".home-slider__pagination",
                        type: "bullets"
                    },
                    navigation: {
                        nextEl: ".home-slider__next",
                        prevEl: ".home-slider__prev"
                    },
                    autoplay: {
                        delay: 5000,
                    },
                    loop: false,
                    breakpoints: {
                        992: {
                            loop: true
                        }
                    },
                });
            }
        }
    }
</script>
